import { FormulaFields } from 'services/store/remixer/types';
import UserLoop from 'pages/Remixer/components/UserLoop';
import FormulaItem from 'pages/Remixer/components/FormulaItem/FormulaItem';
import UndoButton from './components/UndoButton';
import RedoButton from './components/RedoButton';
import {
  StyledContainer,
  StyledDivider,
  StyledGridContainer,
  StyledDeskDivider,
  StyledTimeTravelDivider,
  StyledUserLoopWrapper,
  StyledWrapper,
} from './styled';

const FormulaEditor = () => (
  <StyledGridContainer>
    <StyledContainer>
      <FormulaItem field={FormulaFields.Genre} />
      <StyledDivider orientation="vertical" />
      <FormulaItem field={FormulaFields.Bpm} />
      <StyledDivider orientation="vertical" />
      <FormulaItem field={FormulaFields.Energy} />
      <StyledDivider orientation="vertical" />
      <FormulaItem field={FormulaFields.Duration} />
    </StyledContainer>
    <StyledWrapper>
      <UndoButton />
      <StyledTimeTravelDivider orientation="vertical" />
      <RedoButton />
    </StyledWrapper>
    <StyledDeskDivider orientation="vertical" />
    <StyledUserLoopWrapper>
      <UserLoop />
    </StyledUserLoopWrapper>
  </StyledGridContainer>
);

export default FormulaEditor;
